module.exports = __webpack_public_path__ + "img/logo-settlucas.5d428b7d.png";